export default __webpack_public_path__ + "static/media/noun_Check Box_38652.8db80ed6.png";